// extracted by mini-css-extract-plugin
module.exports = {"modal":"Dialog_modal__3dUOX","content":"Dialog_content__r6QXc","landscapeCutoff":"Dialog_landscapeCutoff__2BTeQ","icon":"Dialog_icon__LXBw1"};